import { Step } from './CheckoutProgressBar.steps';
import { useCheckoutProgressBarStyles } from './CheckoutProgressBar.styles';
import { WizardStep } from './CheckoutProgressBar.types';
import { useMemo } from 'react';
import { useViewport } from '../../../hooks/ViewportHook';
import { ICartWorkflowWizardStep } from '../CartWorkflowWizard/CartWorkflowWizard.types';

export interface ICheckoutProgressBarProps {
    stepIndex: number;
    steps: ICartWorkflowWizardStep[];
}

const CheckoutProgressBar = ({ stepIndex, steps }: ICheckoutProgressBarProps) => {
    const styles = useCheckoutProgressBarStyles();
    const { isDesktop, isTablet } = useViewport();

    const getStep = (i: number, index: number): WizardStep => {
        if (i === 0) return 'start';
        if (i < index) return 'previous';
        if (i === steps.length - 1) return i === index ? 'currentLast' : 'last';
        if (i === index) return 'current';
        return 'future';
    };

    const shouldShowStep = (currentIndex: number, mapIndex: number): boolean => {
        return (
            isDesktop || isTablet || (mapIndex >= currentIndex - 1 && mapIndex <= currentIndex + 1)
        );
    };

    const stepComponents = useMemo(
        () =>
            steps.map((x, i) => {
                const step = getStep(i, stepIndex);
                return shouldShowStep(stepIndex, i) ? (
                    <Step key={x.title} step={step} text={x.title} index={i} />
                ) : null;
            }),
        [steps, stepIndex, isDesktop, isTablet]
    );

    return <div className={styles.root}>{stepComponents}</div>;
};

export default CheckoutProgressBar;
